import './styles/reset.css';
import './styles/tokens.css';
import './styles/theme-dark.css';
import './styles/theme-light.css';
import './styles/globals.css';
import { render } from 'preact';
import { App } from './app';

const root = document.getElementById('app');
if (!root) throw new Error('#app not found');
render(<App />, root);
